/**
 * Shared constants for the application
 */

export const SILENCE_TEXT = '___'

// Layout dimensions
export const FOOTER_HEIGHT = 'calc(var(--spacing) * 16)'
export const HEADER_HEIGHT = 'calc(var(--spacing) * 14)'
export const TOOLBAR_HEIGHT = 'calc(var(--spacing) * 12)'
